// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ReactStripeDemo: MarkdocTagRegistration = {
  tag: 'react-stripe-demo',
  component: 'ReactStripeDemo',
};
